import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { PageHeading } from '@/components/Layout/Parts';
import Text from '@/components/Text';
import { get } from '@/utils/storage';

const DQScheduledActionsPlaceholder: FC = () => {
  const network = get<string>('dq_scheduled_actions_network') ?? 'facebook';

  return (
    <>
      <Text $type="caption" $color="gray">
        EDITORIAL
      </Text>
      <PageHeading>Distribution Queue</PageHeading>
      <Navigate replace to={`./${network}`} relative="path" />
    </>
  );
};

export default DQScheduledActionsPlaceholder;
